module.exports = __webpack_public_path__ + "static/2-ecb319e0ea879c923f5453bea8c8736c.jpeg";